import Api from "../common/Api";

export class SchdService extends Api {
  private static service: SchdService;
  private readonly CRUD: string = process.env.REACT_APP_URL_WP + "/schd";

  public static getInstance(): SchdService {
    if (!SchdService.service) {
      SchdService.service = new SchdService();
    }
    return SchdService.service;
  }

  public async list(search: any) {
    return await super.get<any>(this.CRUD, search);
  }

  public async save(model: any) {
    return await super.post<any>(this.CRUD, model);
  }

  public async deleteById(model: any) {
    return await super.delete<boolean>(this.CRUD, model);
  }

}
